/**
 * Convenience hook that exposes the current user's profile. Reads the same
 * cached data the Shell already populates from /me/permissions, so it's a
 * cheap lookup with no extra network calls.
 *
 * Usage:
 *   const { isSuperadmin } = useMe();
 *   {isSuperadmin && <button>Delete</button>}
 */

import { useQuery } from "@tanstack/react-query";

export interface Me {
  uid: string;
  email: string | null;
  isSuperadmin: boolean;
  permissions: string[];
}

export function useMe(): { isSuperadmin: boolean; permissions: string[]; uid: string | null } {
  const { data } = useQuery<Me>({
    queryKey: ["me"],
    // No queryFn — Shell already fetches it. We just read the cache.
    enabled: false,
  });
  return {
    isSuperadmin: !!data?.isSuperadmin,
    permissions: data?.permissions ?? [],
    uid: data?.uid ?? null,
  };
}
